// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pXYjfghjxPYCeag6K7uf{border:1px solid var(--border-neutral-default);border-radius:8px;padding:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `pXYjfghjxPYCeag6K7uf`
};
export default ___CSS_LOADER_EXPORT___;
